<template lang="html">
  <div class="shopify-app-permissions">
    <Guide
      :content="content"
      contentHeading="Grant App Permissions"
      :contentVideo="contentVideo"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'ShopifyAppPermissions',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'shopify-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'create-shopify-app',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'shopify-credentials',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
          <p>Scroll down to Storefront API and check the option <strong>Allow this app to access your storefront data using the Storefront API</strong>.</p>

          <p>In order to give our platform permission to connect to your store, enable the following options:</p>

          <div class="helper-text">
            <ul>
              <li>
                <p><strong>Read products, variants, and collections</strong></p>
              </li>

              <li>
                <p><strong>Read product tags</strong></p>
              </li>

              <li>
                <p><strong>Read and modify checkouts</strong></p>
              </li>
            </ul>
          </div>

          <p><strong>Save</strong> your changes and click <strong>I understand, create the app</strong>.</p>
        `
    },

    contentVideo() {
      return 'https://page-maker-pro.s3.eu-west-2.amazonaws.com/8++-+COMPUTOR_03.mp4'
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
